import { ObjectsManager } from './Manager';

export default ObjectsManager;
